var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ExpectedAudienceFields'),_c('Divider',{staticClass:"mv-30"}),_c('Protocols'),_c('Divider',{staticClass:"mv-30"}),_c('GeneralDescriptionFields')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }